import { render } from "./IconArrowLeft.vue?vue&type=template&id=2da2c52a"
import script from "./IconArrowLeft.vue?vue&type=script&lang=ts"
export * from "./IconArrowLeft.vue?vue&type=script&lang=ts"
script.render = render

export default script